import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Skeleton/skeleton';
import { css } from '@patternfly/react-styles';
export var Skeleton = function Skeleton(_a) {
  var className = _a.className,
      width = _a.width,
      height = _a.height,
      fontSize = _a.fontSize,
      shape = _a.shape,
      screenreaderText = _a.screenreaderText,
      props = __rest(_a, ["className", "width", "height", "fontSize", "shape", "screenreaderText"]);

  var fontHeightClassName = fontSize ? Object.values(styles.modifiers).find(function (key) {
    return key === "pf-m-text-".concat(fontSize);
  }) : undefined;
  return React.createElement("div", Object.assign({}, props, {
    className: css(styles.skeleton, fontSize && fontHeightClassName, shape === 'circle' && styles.modifiers.circle, shape === 'square' && styles.modifiers.square, className)
  }, (width || height) && {
    style: Object.assign({
      '--pf-c-skeleton--Width': width ? width : undefined,
      '--pf-c-skeleton--Height': height ? height : undefined
    }, props.style)
  }), React.createElement("span", {
    className: "pf-u-screen-reader"
  }, screenreaderText));
};
Skeleton.displayName = 'Skeleton';